<script setup lang="ts">
import { computed, toRefs, unref } from 'vue';

export type Props = {
  icon: string;
  fill?: boolean;
};

const props = defineProps<Props>();
const { fill } = toRefs(props);

const iconClass = computed(() => ({ 'icon--fill': unref(fill) }));
</script>

<template>
  <span class="material-symbols-outlined icon" :class="iconClass">{{ icon }}</span>
</template>

<style scoped lang="scss">
.icon {
  font-size: inherit;

  &--fill {
    font-variation-settings: 'FILL' 1;
  }
}
</style>
